<template>
  <div class="flex" :class="{'cti-is-login': isLoggedIn, 'cti-not-login': !isLoggedIn}">
    <vs-input :placeholder="$tc('extension')" class="mr-2 navbar-extension-input" v-model="extension"/>
    <cti-login
      class="mr-2"
      :socket="socket" :servers="servers"
      @listenToIncomingCalls="listenToIncomingCalls"
      @disconnectToIncomingCalls="disconnectToIncomingCalls">
    </cti-login>

    <!-- /.Call Test Here -->

    <vs-chip class="cti-login-text-status mr-8" :color="isLoggedIn ? 'success' : 'danger'">
      <span v-if="isLoggedIn" v-text="$t('you_are_logged_in')"></span>
      <span v-else v-text="$t('you_are_logged_out')"></span>
    </vs-chip>

    <template v-if="isLoggedIn">
      <cti-call-test :server="servers" v-if="!this.isProduction" class="mr-2"></cti-call-test>
      <cti-dnd type="rest" :server="servers" class="mr-2"></cti-dnd>
      <cti-dnd type="lunch" :server="servers" class="mr-2"></cti-dnd>
      <cti-dnd type="after" :server="servers" class="mr-2"></cti-dnd>
    </template>

    <callback-count-button></callback-count-button>

    <template v-if="isLoggedIn">
      <vs-input :placeholder="$tc('phone_number')" class="mr-2 ml-2 hide-at-1000" v-model="phoneNumber" style="max-width: 150px;"/>
    </template>

    <template v-if="isLoggedIn">
      <cti-dial :server="servers" v-if="$store.getters.hasPermission('dial')" class="mr-2 hide-at-1000"></cti-dial>
      <cti-blind-transfer :server="servers" v-if="$store.getters.hasPermission('blindtransfer')" class="mr-2 hide-at-1000"></cti-blind-transfer>
      <cti-attended-transfer :server="servers" v-if="$store.getters.hasPermission('attendedtransfer')" class="mr-2 hide-at-1000"></cti-attended-transfer>
      <cti-transfer :server="servers" v-if="$store.getters.hasPermission('transfer')" class="mr-2 hide-at-1000"></cti-transfer>
      <cti-listen :server="servers" v-if="$store.getters.hasPermission('listen')" class="mr-2 hide-at-1000"></cti-listen>
      <cti-whisper :server="servers" v-if="$store.getters.hasPermission('whisper')" class="mr-2 hide-at-1000"></cti-whisper>
    </template>
    <button @click="openIncomingCall" style="display:none;" ref="incomingCallBtn">Open Incoming Call</button>
  </div>
</template>

<script>
import io from 'socket.io-client'
import CtiLogin from '@/components/cti/Login'
import CtiDnd from '@/components/cti/Dnd'
import CtiCallTest from '@/components/cti/CallTest'
import CtiDial from '@/components/cti/Dial'
import CtiBlindTransfer from '@/components/cti/BlindTransfer'
import CtiAttendedTransfer from '@/components/cti/AttendedTransfer'
import CtiListen from '@/components/cti/Listen'
import CtiWhisper from '@/components/cti/Whisper'
import CtiTransfer from '@/components/cti/Transfer'
import CallbackCountButton from '@/components/buttons/CallbackCountButton'
import { EventBus } from '@/../eventbus'
import Utils from '@/helpers/utils'
import announcementSocket from '@/libs/sockets/announcements'
import appConfig from '@/config/app'

export default {
  name: 'Cti',
  components: {
    CtiLogin,
    CtiDnd,
    CtiCallTest,
    CtiDial,
    CtiBlindTransfer,
    CtiAttendedTransfer,
    CtiListen,
    CtiWhisper,
    CtiTransfer,
    CallbackCountButton
  },
  data () {
    return {
      socket: {},
      incomingData: {}
    }
  },
  computed: {
    extension: {
      get () {
        return this.$store.getters.extension
      },
      set (value) {
        this.$store.dispatch('setExtension', value)
      }
    },
    phoneNumber: {
      get () {
        return this.$store.getters.phoneNumber
      },
      set (value) {
        this.$store.dispatch('setPhoneNumber', value)
      }
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    servers () {
      return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.servers : {}
    },
    isProduction () {
      return appConfig.envState === 'production'
    }
  },
  async mounted () {
    // TODO: Remove this if not needed.
    // const response = await Node.getServerAndNodeByLoggedInUser()
    // await this.$store.dispatch('setNodeServers', response.data.server)

    if (window.opener === null) {
      this.listenToIncomingCalls()
    }

    if (this.extension === null) {
      this.extension = this.$store.getters.userInfo.extension
    }

    if (this.extension && this.extension.toString().length > 0) {
      this.$store.dispatch('ctiLoading', { socket: this.socket, domain: this.servers.domain })
    }
  },
  methods: {
    inboundModal (data) {
      EventBus.$emit('initInboundModal', data)
      $('#inboundModal').modal('show') // eslint-disable-line
    },
    openIncomingCall () {
      Utils.openPopUp('window', 'inbound', this.incomingData, this.inboundModal)
    },
    listenToIncomingCalls () {
      this.socket = io.connect(`${this.servers.call_listener.domain}:${this.servers.call_listener.port}`, { transports: ['websocket'] })

      this.socket.on('IncomingCall', async data => {
        if (data.cid !== 'CLOSE') {
          this.incomingData = data
          await this.$store.dispatch('updateSipChannel', this.incomingData.agi_arg_5)
          await this.$store.dispatch('updateSipExtension', this.extension)
          this.$refs.incomingCallBtn.click()
        }
      })

      // Test
      announcementSocket.setNode(this.servers) // Set Node. This will be rejected if node was already set. TODO: Put this on a initial file
      announcementSocket.getSocket().on('refresh_dnd', async (data) => {
        await this.$store.dispatch('ctiLoading', { socket: this.socket, domain: this.servers.domain })

        switch (data.type) {
        case 'enable':
          this.$vs.notify({
            title: 'DND update',
            text: `Your dnd status has been enabled by: ${data.username}`,
            color:'warning',
            position:'top-right'
          })
          break
        case 'disable':
          this.$vs.notify({
            title: 'DND update',
            text: `Your dnd status has been disabled by: ${data.username}`,
            color:'warning',
            position:'top-right'
          })
          break
        }
      })
    },
    disconnectToIncomingCalls () {
      this.socket.disconnect()
      this.socket = {}
    }
  }
}
</script>

<style scoped>
.navbar-extension-input {
  max-width: 150px;
}
.cti-login-text-status {
  //margin-right: 10px !important;
}
.call-back-count-button {
  margin-right: 10px !important;
}
/* For screens smaller than 768px (e.g., tablets and phones) */
@media (max-width: 817px) {
  .cti-not-login .cti-login-text-status {
    display: none;
  }
}
@media (max-width: 650px) {
  .cti-not-login .call-back-count-button-container {
    display: none;
  }
}
@media (max-width: 650px) {
  .cti-not-login .navbar-extension-input {
    max-width: 90px;
  }
}

@media (max-width: 1250px) {
  .cti-is-login .navbar-extension-input {
    max-width: 90px;
  }
}

@media (max-width: 1460px) {
  .cti-is-login .cti-login-text-status {
    display: none;
  }
}
@media (max-width: 1320px) {
  .cti-is-login .call-back-count-button-container {
    display: none;
  }
}
@media (max-width: 1000px) {
  .hide-at-1000 {
    display: none;
  }
}

@media (max-width: 500px) {
  .cti-is-login .navbar-extension-input {
    display: none;
  }
}


</style>
